var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.41421356,4 L7.70710678,6.29289322 C8.09763107,6.68341751 8.09763107,7.31658249 7.70710678,7.70710678 C7.31658249,8.09763107 6.68341751,8.09763107 6.29289322,7.70710678 L4,5.41421356 L1.70710678,7.70710678 C1.31658249,8.09763107 0.683417511,8.09763107 0.292893219,7.70710678 C-0.0976310729,7.31658249 -0.0976310729,6.68341751 0.292893219,6.29289322 L2.58578644,4 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L4,2.58578644 L6.29289322,0.292893219 C6.68341751,-0.0976310729 7.31658249,-0.0976310729 7.70710678,0.292893219 C8.09763107,0.683417511 8.09763107,1.31658249 7.70710678,1.70710678 L5.41421356,4 Z",
    id: "path-1-close"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop/Product-Page-Design-Interactions",
    transform: "translate(-962.000000, -3354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header-Copy",
    transform: "translate(0.000000, 3330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(165.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(503.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(282.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/12px/Close",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Boundaries"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-close",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-close"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1-close"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-Gray",
    mask: "url(#mask-2-close)",
    fill: "#808080"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.4cd268ab994c18b3dd0abd0995a2ddf1.svg";
export { ForwardRef as ReactComponent };